export const PF_WIDGET_FREEZE_TABLE_GROUPED_DEFAULT =
  'pf-widget-table-freeze-grouped';

export const PF_WIDGET_FREEZE_TABLE_NORMAL_DEFAULT =
  'pf-widget-table-freeze-normal';

export const WIDGET_FREEZE_TABLE_KEY = 'pf-widget-datatable-freeze';

export const WIDGET_FREEZE_TABLE_KEY_BY_TEMPLATE_ID =
  'pf-widget-freeze-template';
